class FenoPriceCalculator extends HTMLElement {
  connectedCallback() {
    this.productInputs = this.querySelectorAll('.feno-calculator__product-input');
    this.vehicleInputs = this.querySelectorAll('.feno-calculator__vehicle-input');
    this.districtSelect = this.querySelector('select[name="district"]');
    this.resultValue = this.querySelector('[data-result]');
    this.resultNote = this.querySelector('[data-result-note]');
    this.vehicleNote = this.querySelector('[data-vehicle-note]');
    this.orderButton = this.querySelector('[data-order-button]');
    this.orderForm = this.querySelector('[data-order-form]');
    this.orderSummary = this.querySelector('[data-order-summary]');
    this.orderFields = {
      product: this.querySelector('[data-order-field="product"]'),
      vehicle: this.querySelector('[data-order-field="vehicle"]'),
      district: this.querySelector('[data-order-field="district"]'),
      price: this.querySelector('[data-order-field="price"]'),
    };

    // Se o formulário já foi submetido com sucesso (a página recarregou após
    // o envio), o servidor deixou a mensagem de sucesso no HTML: revelamos o
    // contentor já aberto e nunca mais o voltamos a esconder.
    this.hasSuccess = !!(this.orderForm && this.orderForm.querySelector('[data-order-success]'));
    if (this.hasSuccess && this.orderForm) {
      this.orderForm.hidden = false;
    }
    this.orderOpen = false;

    if (!this.productInputs.length || !this.districtSelect || !this.resultValue) return;

    this.productInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.productInputs.forEach((otherInput) => {
          const card = otherInput.closest('.feno-calculator__product-card');
          if (card) card.classList.toggle('is-selected', otherInput.checked);
        });
        this.updatePrice();
      });
    });

    this.vehicleInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.vehicleInputs.forEach((otherInput) => {
          const pill = otherInput.closest('.feno-calculator__vehicle-pill');
          if (pill) pill.classList.toggle('is-selected', otherInput.checked);
        });
        if (this.vehicleNote) {
          this.vehicleNote.textContent = input.dataset.note || '';
        }
        this.updatePrice();
      });
    });

    this.districtSelect.addEventListener('change', this.updatePrice.bind(this));

    if (this.orderButton) {
      this.orderButton.addEventListener('click', () => {
        this.orderOpen = true;
        this.updatePrice();
        if (this.orderForm) {
          this.orderForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    this.updatePrice();
  }

  getSelectedVehicleInput() {
    return Array.prototype.find.call(this.vehicleInputs, (input) => input.checked);
  }

  updatePrice() {
    const productInput = Array.prototype.find.call(this.productInputs, (input) => input.checked);
    const vehicleInput = this.getSelectedVehicleInput();
    const districtOption = this.districtSelect.options[this.districtSelect.selectedIndex];
    const vehicleKey = vehicleInput ? vehicleInput.value : null;

    let canOrder = false;
    let total = null;

    if (productInput && vehicleInput && districtOption && districtOption.value) {
      const rawProductPrice = productInput.dataset[`price${this.capitalize(vehicleKey)}`];
      const rawDistrictPrice = districtOption.dataset[`price${this.capitalize(vehicleKey)}`];
      const productPrice = parseFloat((rawProductPrice || '').replace(',', '.'));
      const districtPrice = parseFloat((rawDistrictPrice || '').replace(',', '.'));

      if (
        rawProductPrice &&
        rawDistrictPrice &&
        !Number.isNaN(productPrice) &&
        !Number.isNaN(districtPrice) &&
        productPrice > 0 &&
        districtPrice > 0
      ) {
        total = productPrice + districtPrice;
        canOrder = true;
      }
    }

    if (canOrder) {
      const formatted = new Intl.NumberFormat('pt-PT', {
        style: 'currency',
        currency: 'EUR',
      }).format(total);

      this.resultValue.textContent = formatted;
      if (this.resultNote) {
        this.resultNote.dataset.defaultText = this.resultNote.dataset.defaultText || this.resultNote.textContent;
        this.resultNote.textContent = this.dataset.noteAvailable || 'Preço por carga completa, IVA incluído. Sujeito a confirmação final.';
      }

      const summary = `${productInput.dataset.name} · ${vehicleInput.dataset.name} · ${districtOption.textContent.trim()}`;
      if (this.orderSummary) this.orderSummary.textContent = `${summary} — ${formatted}`;
      if (this.orderFields.product) this.orderFields.product.value = productInput.dataset.name;
      if (this.orderFields.vehicle) this.orderFields.vehicle.value = vehicleInput.dataset.name;
      if (this.orderFields.district) this.orderFields.district.value = districtOption.textContent.trim();
      if (this.orderFields.price) this.orderFields.price.value = formatted;
    } else {
      this.resultValue.textContent = '—';
      if (this.resultNote) {
        this.resultNote.dataset.defaultText = this.resultNote.dataset.defaultText || this.resultNote.textContent;
        const allSelected = !!(productInput && vehicleInput && districtOption && districtOption.value);
        this.resultNote.textContent = allSelected
          ? (this.dataset.noteUnavailable || 'Preço ainda não disponível para esta combinação. Contacte-nos para orçamento.')
          : this.resultNote.dataset.defaultText;
      }
      this.orderOpen = false;
    }

    if (this.orderButton) this.orderButton.hidden = !canOrder;

    if (this.orderForm && !this.hasSuccess) {
      this.orderForm.hidden = !(canOrder && this.orderOpen);
    }
  }

  capitalize(value) {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}

if (!customElements.get('feno-price-calculator')) {
  customElements.define('feno-price-calculator', FenoPriceCalculator);
}
